import styled, { keyframes } from "styled-components";
import { css } from "styled-components";

const pulseAnimation = (color: string) => keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 ${color}B3;
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px ${color}00;
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 ${color}00;
  }
`;

const StatusCircle = styled.div<{ $animated?: boolean }>`
  margin-right: 8px;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background: ${(props) => props.color || props.theme.colors.primaryBlue};
  ${(p) =>
    (p.$animated ?? true) &&
    css`
      opacity: 1;
      box-shadow: 0 0 0 0 ${p.color}FF;
      transform: scale(1);
      animation: ${pulseAnimation(p.color || p.theme.colors.primaryBlue)} 2s
        infinite;
      margin-right: 12px;
    `}
}
`;

export { StatusCircle };
